export default __webpack_public_path__ + "static/media/j_wdt_c_4_5.5ca3ee8d.mp3";